<template>
  <div>
    <div v-if="isEditingOrNoAddingPhysicalAddress" class="row">
      <div class="col-12 mt-3 ml-3">
        <icon-view
          class="p-1 mr-2 rounded-circle"
          :icon="isEditing ? 'fas fa-edit' : 'fas fa-plus'"
          icon-background="white"
          icon-color="#2EB882"
          icon-size="14px"
          :title="title"
        />
      </div>
    </div>
    <div class="p-4">
      <validation-observer
        :ref="'addressForm' + model.id"
        v-slot="{}"
        tag="form"
      >
        <div class="row">
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              :name="'addressType'"
              rules="required"
            >
              <custom-drop-down
                v-model="addressTypeSelected"
                custom-error-msg="El tipo de dirección es requerida."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Dirección:"
                :options="addressTypes"
                placeholder="Seleccione"
                @input="onChangeAddressType"
              />
            </validation-provider>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="addressLine1"
              rules="required"
            >
              <label class="data-title mb-0">Dirección (Línea 1):</label>
              <custom-input
                v-model="model.addressLine1"
                :custom-error-msg="'La dirección (línea 1) es requerida.'"
                :error="errors[0]"
              />
            </validation-provider>
          </div>

          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="addressMunicipality"
              rules="required"
            >
              <label class="data-title mb-0">Municipio:</label>
              <custom-drop-down
                v-model="municipalitySelected"
                custom-error-msg="El municipio es requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="municipalities"
                placeholder="Seleccione"
                @input="onChangeMunicipality"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="addressPostalCode"
              rules="required"
            >
              <custom-input
                v-model="model.zipCode"
                :custom-error-msg="'El código postal es requerido.'"
                :error="errors[0]"
                label="Código Postal:"
                mask-type="ZipcodeExt"
                placeholder="#####-####"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-4">
            <label class="data-title mb-0">Dirección (Línea 2):</label>
            <custom-input v-model="model.addressLine2" />
          </div>

          <div class="col-md-4">
            <label class="data-title mb-0">Latitud:</label>
            <custom-input
              type="number"
              :value="model.latitude"
              @input="(val) => (model.latitude = Number.parseFloat(val))"
            />
          </div>
          <div class="col-md-4">
            <label class="data-title mb-0">Longitud:</label>
            <custom-input
              type="number"
              :value="model.longitude"
              @input="(val) => (model.longitude = Number.parseFloat(val))"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-4">
            <label class="data-title mb-0">Dirección (Línea 3):</label>
            <custom-input v-model="model.addressLine3" />
          </div>
          <div class="col-md-8">
            <label class="data-title mb-0">Anotaciones Adicionales:</label>
            <custom-input
              v-model="model.additionalAnnotations"
              placeholder="Escribir información adicional de como llegar..."
            />
          </div>
        </div>
      </validation-observer>

      <div v-if="isEditingOrNoAddingPhysicalAddress" class="row mt-5">
        <div class="col-12">
          <action-button
            class="float-right ml-2"
            i="fas fa-save fa-lg"
            text="Guardar"
            variant="success"
            @click="save"
          />
          <action-button
            class="float-right"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger"
            @click="cancel"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
export default {
  name: 'AddressFormItem',
  components: {
    ValidationProvider,
    CustomDropDown,
    CustomInput,
    IconView,
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    municipalities: {
      type: Array,
      default: () => [],
    },
    addressTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      municipalitySelected: null,
      addressTypeSelected: null,
      model: { ...this.value },
    };
  },
  computed: {
    isEditing() {
      return Boolean(this.model.id);
    },
    isPhysicalAddress() {
      return Boolean(this.model?.isPhysicalAddress);
    },
    isEditingOrNoAddingPhysicalAddress() {
      if (this.isEditing) return true;
      return !this.isPhysicalAddress;
    },
    title() {
      const first = this.isEditing ? 'Editar' : 'Añadir';
      const last = this.isEditing ? this.model.addressTypeDescription : '';
      return `${first} Dirección ${last}`;
    },
  },
  methods: {
    onChangeMunicipality(item) {
      this.model.municipalityId = item?.id;
    },
    onChangeAddressType(item) {
      this.model.addressTypeCd = item?.id;
    },
    setMunicipalitySelected(id) {
      if (this.municipalitySelected) return;
      if (!id) {
        this.municipalitySelected = null;
        return;
      }

      this.municipalitySelected = this.municipalities.find((y) => y.id === id);
    },
    setAddressTypeSelected(id) {
      if (this.addressTypeSelected) return;
      if (!id) {
        this.addressTypeSelected = null;
        return;
      }

      this.addressTypeSelected = this.addressTypes.find((y) => y.id === id);
    },
    async save() {
      let reff = 'addressForm' + this.model.id;
      const isFormValid = await this.$refs[reff].validate();
      if (isFormValid) this.$emit('save');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
  watch: {
    model: {
      deep: true,
      immediate: true,
      handler(value) {
        this.setMunicipalitySelected(value.municipalityId);
        this.setAddressTypeSelected(value.addressTypeCd);
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped lang="scss"></style>
